import React, {useEffect, useRef, useMemo} from 'react';
import {Chart} from "primereact/chart";
import moment from "moment";

type Props = {
    logs:   any[];
    orders: any[];
};

const MONTHS = Array.from({length: 6}, (_, i) =>
    moment().subtract(i, 'months').format('MMMM')
);

const CHART_OPTIONS = {
    maintainAspectRatio: false,
    aspectRatio: 0.6,
    plugins: {legend: {labels: {color: '#495057'}}},
    scales: {
        x: {ticks: {color: '#495057'}, grid: {color: '#ebedef'}},
        y: {ticks: {color: '#495057'}, grid: {color: '#ebedef'}},
    },
};

const TransactionChart: React.FC<Props> = ({logs, orders}) => {
    const chartRef = useRef<any>(null);

    // Explicitly destroy the Chart.js instance on unmount so the canvas is
    // freed before React StrictMode's double-invoke creates a second chart.
    useEffect(() => {
        return () => {
            try {
                chartRef.current?.getChart?.()?.destroy();
            } catch (_) {}
        };
    }, []);

    const chartData = useMemo(() => ({
        labels: MONTHS,
        datasets: [
            {
                label:       'Transactions',
                data:        MONTHS.map(m => orders.filter(o =>
                    moment(o.createdAt?.toDate ? o.createdAt.toDate() : o.createdAt)
                        .format('MMMM') === m).length),
                fill:        false,
                borderColor: '#42A5F5',
                tension:     0.4,
            },
            {
                label:       'Views',
                data:        MONTHS.map(m => logs.filter(l =>
                    moment(l.date?.toDate ? l.date.toDate() : l.date, 'YYYY-MM-DDTh:mm:ss')
                        .format('MMMM') === m).length),
                fill:        false,
                borderColor: '#FFA726',
                tension:     0.4,
            },
        ],
    }), [logs, orders]);

    return (
        <div style={{position:'relative', height:240}}>
            <Chart ref={chartRef} type="line" data={chartData} options={CHART_OPTIONS}/>
        </div>
    );
};

export default TransactionChart;
